<template>
  <SkeletonLoader>
    <div class="cf-skeleton">
      <!-- Patient info card -->
      <div class="cf-skeleton__card">
        <div class="cf-skeleton__patient">
          <div class="sk-circle sk-circle--lg"></div>
          <div class="cf-skeleton__patient-info">
            <div class="sk-line sk-line--lg" style="width: 45%; margin-bottom: 6px;"></div>
            <div class="cf-skeleton__pills">
              <div class="sk-rect" v-for="i in 3" :key="'pill-'+i" :style="{ height: '22px', width: pillWidths[i], borderRadius: '12px' }"></div>
            </div>
            <div class="sk-line sk-line--sm" style="width: 60%; margin-top: 6px;"></div>
          </div>
        </div>
      </div>

      <!-- Status indicators -->
      <div class="cf-skeleton__statuses">
        <div class="cf-skeleton__status-card" v-for="i in 2" :key="'status-'+i">
          <div class="sk-line sk-line--sm" style="width: 40%;"></div>
          <div class="sk-line sk-line--lg" :style="{ width: statusWidths[i] }"></div>
        </div>
      </div>

      <!-- Action section -->
      <div class="cf-skeleton__card">
        <div class="sk-line sk-line--title" style="width: 35%;"></div>
        <div class="sk-rect" style="height: 36px; width: 100%; border-radius: 6px; margin-bottom: 12px;"></div>
        <div class="sk-rect" style="height: 80px; width: 100%; border-radius: 6px; margin-bottom: 12px;"></div>
        <div class="sk-rect" style="height: 36px; width: 140px; border-radius: 8px;"></div>
      </div>

      <!-- Activity log -->
      <div class="cf-skeleton__card">
        <div class="sk-line sk-line--title" style="width: 30%;"></div>
        <div v-for="i in 4" :key="'log-'+i" class="cf-skeleton__log-row">
          <div class="sk-circle sk-circle--sm"></div>
          <div class="sk-col">
            <div class="sk-line" :style="{ width: logWidths[i] }"></div>
            <div class="sk-line sk-line--sm" style="width: 25%;"></div>
          </div>
        </div>
      </div>
    </div>
  </SkeletonLoader>
</template>

<script>
import SkeletonLoader from '@/components/SkeletonLoader.vue';

export default {
  name: 'CreateFollowupSkeleton',
  components: { SkeletonLoader },
  data() {
    return {
      pillWidths: { 1: '90px', 2: '110px', 3: '80px' },
      statusWidths: { 1: '60%', 2: '50%' },
      logWidths: { 1: '70%', 2: '55%', 3: '80%', 4: '45%' },
    };
  }
}
</script>

<style lang="scss" scoped>
.cf-skeleton {
  padding: 16px 20px;
}

.cf-skeleton__card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 14px;
}

.cf-skeleton__patient {
  display: flex;
  gap: 14px;
  align-items: flex-start;
}

.cf-skeleton__patient-info {
  flex: 1;
}

.cf-skeleton__pills {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.cf-skeleton__statuses {
  display: flex;
  gap: 12px;
  margin-bottom: 14px;
}

.cf-skeleton__status-card {
  flex: 1;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 14px;
}

.cf-skeleton__log-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid #f1f5f9;

  &:last-child { border-bottom: none; }
}

@media (max-width: 768px) {
  .cf-skeleton__statuses {
    flex-direction: column;
  }
}
</style>
